var SETTING_BREAKING_NEWS = 'homepage.breaking-news';
var SETTING_TRENDING_TAGS = 'homepage.trending-tags';
var SETTING_SPONSOR = 'homepage.sponsor';
var SETTING_LIVE_VIDEO_ID = 'global.liveYouTubeId';

angular.module('admin.homepage.index', [

  'resources.Settings',
  'resources.Tag',
  'ngFileUpload',

]).config(["$stateProvider", function($stateProvider){
  $stateProvider.state('admin.homepage', {
    url: '/homepage',
    title: 'Home page settings',
    views: {
      'main@': {
        template: require('./homepage.tpl.html'),
        controller: 'HomePageCtrl',
        resolve: {
          setting: ["Settings", function(Settings) {
            return Settings.get([SETTING_BREAKING_NEWS, SETTING_TRENDING_TAGS, SETTING_SPONSOR, SETTING_LIVE_VIDEO_ID]).$promise;
          }],
          // collectTags: function (Tag) {
          //   return Tag.query().$promise;
          // }

        }
      }
    }
  });

}]).controller( 'HomePageCtrl', ["$scope", "$log", "setting", "Settings", "Upload", "APP_IMG_URLS", "Tag", function($scope, $log, setting, Settings, Upload, APP_IMG_URLS, Tag) {

  $scope.collectTags = [];
  $scope.dataLoaded = false;
  Tag.query().$promise.then( function(res) {
    $scope.collectTags = res.data;
    $scope.dataLoaded = true;
  }, function(err) {
    $scope.dataLoaded = true;
    console.error( 'error loading tags');
    console.error(err);
  });
  // console.log( '>>', $scope.tags );

  var ActionStates = require('../../utils/action-states').StateClass;
  if( setting[0].value ) {
    var value = JSON.parse(setting[0].value);
    $scope.text = value.text;
    $scope.url = value.url;
  } else {
    $scope.text = '';
    $scope.url = '';
  }
  if( setting[1].value ) {
    $scope.tags = JSON.parse(setting[1].value);
  } else {
    $scope.tags = [];
  }

  if( setting[2].value ) {
    $scope.sponsor = JSON.parse(setting[2].value);
  } else {
    $scope.sponsor = {
      image: null,
      url: ''
    };
  }

  if( setting[3].value ) {
    $scope.youtubeLiveId = setting[3].value;
  } else {
    $scope.youtubeLiveId = "";
  }


  $scope.image_uploading = false;
  $scope.$watch('sponsor', function (file) {
    if (file && file.type && file.type.startsWith('image/'))  {
      $scope.uploadSponsorImage(file);
    }
  });

  $scope.uploadSponsorImage = function (file) {
    $scope.image_uploading = true;
    Upload.upload({
      url: '/api/articles/upload',
      data: {file: file}
    }).then(function (resp) {
      $scope.image_uploading = false;
      $scope.sponsor.image = APP_IMG_URLS.base + resp.data.filename;
    }, function (resp) {
      $scope.image_uploading = false;
      console.log('Error status: ' + resp.status);
    }, function (evt) {
      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
    });
  };

  $scope.error = null;
  $scope.status = new ActionStates();
  $scope.statusRemoveBanner = new ActionStates();

  $scope.initStates = function() {
    $scope.error = null;
    $scope.status.reset();
    $scope.statusRemoveBanner.reset();
  };

  $scope.save = function (e) {
    console.log( '>>>', $scope.sponsor );

    $scope.initStates();
    $scope.status.waiting();
    Settings.set([{
      name: SETTING_BREAKING_NEWS,
      value: JSON.stringify({
        text: $scope.text,
        url: $scope.url
      })
    }, {
      name: SETTING_TRENDING_TAGS,
      value: JSON.stringify($scope.tags.map(function(t) {
        return {
          _id: t._id,
          name: t.name,
          sefriendly: t.sefriendly,
          oficial: t.oficial,
          avatar: t.avatar
        };
      }))
    }, {
      name: SETTING_SPONSOR,
      value: JSON.stringify({
        image: $scope.sponsor.image,
        url: $scope.sponsor.url
      })
    }, {
      name: SETTING_LIVE_VIDEO_ID,
      value: $scope.youtubeLiveId
    }]).$promise.then(function (data) {
      // console.log( '>>', data );
      if( data.error ) {
        $scope.error = data.error;
        $scope.status.error();
      } else {
        $scope.status.saveOk();
      }
    }, function (e) {
      $log.error(e);
      $scope.error = e.statusText;
      $scope.status.error();
    });
  };

  $scope.removeBanner = function () {
    $scope.initStates();
    $scope.statusRemoveBanner.waiting();
    Settings.set({
      name: SETTING_BREAKING_NEWS,
      value: null
    }).$promise.then(function (data) {
      if( data.error ) {
        $scope.error = data.error;
        $scope.statusRemoveBanner.error();
      } else {
        $scope.text = '';
        $scope.url = '';
        $scope.statusRemoveBanner.saveOk();
      }
    }, function (e) {
      $log.error(e);
      $scope.error = e.statusText;
      $scope.statusRemoveBanner.error();
    });
  };

}]);




// WEBPACK FOOTER //
// ./client/src/app/admin/homepage/homepage.js